// extracted by mini-css-extract-plugin
var _1 = "ApplicantIdentityWidgetMessage-modulelabel__wK02X";
var _2 = "ApplicantIdentityWidgetMessage-modulemessage__Dk4Ch";
var _3 = "ApplicantIdentityWidgetMessage-moduletext__Vke_V";
export { _1 as "label", _2 as "message", _3 as "text" }
